<template>
  <div class="contact-page container-fluid py-5">
    <h1 class="title">About Us</h1>
    <section class="about-page container-fluid text-center my-5">
    <div class="about-text mb-5">
      <h2 class="about-heading">
        We are the premier book retailing platform in <br />
        Dhaka, Bangladesh, delivered over 15,000 books. Promoting<br />
        a lifelong love for reading.
      </h2>
    </div>
    <div class="about-image">
      <img
        src="https://demo2.pavothemes.com/bookory/wp-content/uploads/2022/02/About_04.jpg"
        alt="Book Store"
        class="img-fluid rounded-4"
      />
    </div>

    <section class="our-story-section container my-5">
      <!-- Our Story Header -->
      <div class="text-center mb-5">
        <h2 class="story-title">Our Story</h2>
      </div>

      <!-- Story Content Grid -->
      <div class="row g-4 mb-5">
        <!-- Retail Stores -->
        <div class="col-md-6">
          <div class="story-card">
            <h3 class="story-card-title">THE JOURNEY</h3>
            <p class="story-card-text">
              What began as a small corner of passion for books has grown into
              one of Bangladesh's most trusted names in book retail. From
              stacking a few titles on homemade shelves to fulfilling hundreds
              of orders a week, our story is rooted in the love of literature
              and the drive to serve readers better. Each step we've taken has
              been powered by a commitment to accessibility, affordability, and
              authenticity.
            </p>
          </div>
        </div>

        <!-- E-commerce and Internet Services -->
        <div class="col-md-6">
          <div class="story-card">
            <h3 class="story-card-title">E-COMMERCE AND INTERNET SERVICES</h3>
            <p class="story-card-text">
              In response to the changing habits of modern readers, we expanded
              our presence online—bringing our entire catalog to fingertips
              nationwide. Our e-commerce platform isn't just a bookstore; it's a
              full-fledged service hub offering book curation, doorstep
              delivery, and now wholesale support through digital channels.
              Whether you're a reader or a retailer, we make book buying
              efficient, affordable, and reliable.
            </p>
          </div>
        </div>

        <!-- Wholesale Distribution -->
        <div class="col-md-6">
          <div class="story-card">
            <h3 class="story-card-title">WHOLESALE DISTRIBUTION</h3>
            <p class="story-card-text">
              As demand for quality books grew, so did our capabilities. We now
              partner with publishers and bookstores nationwide, offering a
              seamless wholesale distribution service tailored for schools,
              libraries, businesses, and retailers. With a robust inventory,
              real-time order tracking, and flexible volume pricing, we ensure
              our wholesale clients receive reliable service and timely
              deliveries, no matter the scale.
            </p>
          </div>
        </div>

        <!-- Additional Content -->
        <div class="col-md-6">
          <div class="story-card">
            <p class="story-card-text">
              Our e-commerce platform is designed to do more than just sell
              books—it's built to support the entire reading ecosystem. From
              personalized recommendations and pre-order campaigns to bulk
              purchasing options and seasonal promotions, we continuously
              optimize the experience for both individual readers and wholesale
              partners. With secure payment gateways, responsive customer
              support, and nationwide delivery coverage, we make sure every
              order is smooth from click to doorstep.
            </p>
          </div>
        </div>
      </div>

      <!-- Images Section -->
      <div class="row g-4 mb-5">
        <div class="col-md-6">
          <div class="story-image">
            <img
              src="https://demo2.pavothemes.com/bookory/wp-content/uploads/2022/02/About_03.png"
              alt="Books display"
              class="img-fluid rounded-4"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="story-image">
            <img
              src="https://demo2.pavothemes.com/bookory/wp-content/uploads/2022/02/About_02.png"
              alt="Person reading by window"
              class="img-fluid rounded-4"
            />
          </div>
        </div>
      </div>

      <div class="bottom-text">
        <p class="mb-4">
          At the heart of everything we do is a promise of reliability, trust,
          and uncompromised quality. Whether you're ordering a single book or a
          bulk shipment, you can count on us to deliver with care, accuracy, and
          dedication. We believe trust is earned through consistency, and
          quality is non-negotiable. From careful packaging to timely delivery,
          we ensure every order reflects our commitment to reliable service and
          a passion for excellence.
        </p>
      </div>
    </section>
  </section>
    <div class="container">      
      <!-- Contact Form & Map -->
      <h2 class="title">Contact</h2>
      <div class="row align-items-start g-4 mb-5">
        <!-- Google Map -->
        <div class="col-md-6">
          <div class="map-container rounded overflow-hidden shadow-sm">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d913.0961128602089!2d90.3866454!3d23.7336661!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b90cd0cdbe6f%3A0xb99d938a125d3c2d!2z4Kao4KeA4Kay4KaV4KeN4Ka34KeH4KakIERvdCBDb20!5e0!3m2!1sen!2sbd!4v1763746212938!5m2!1sen!2sbd"
              width="100%"
              height="450"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
  
        <!-- Contact Form -->
        <div class="col-md-6">
          <h4 class="contact-title">We Would Love To Hear From You.</h4>
          <p class="contact-subtitle">
            Your email address will not be published. Required fields are marked *
          </p>
          <form @submit.prevent="submitForm">
            <div class="mb-3">
              <input
                type="text"
                class="form-control form-control-lg rounded-pill"
                placeholder="Name *"
                v-model="form.name"
                required
              />
            </div>
            <div class="mb-3">
              <input
                type="email"
                class="form-control form-control-lg rounded-pill"
                placeholder="Email *"
                v-model="form.email"
                required
              />
            </div>
            <div class="mb-3">
              <textarea
                class="form-control form-control-lg rounded-4"
                rows="4"
                placeholder="Message *"
                v-model="form.message"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              class="btn btn-primary btn-lg rounded-pill px-4"
              :disabled="isLoading"
            >
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              Submit <span class="ms-1">&rsaquo;</span>
            </button>
          </form>
        </div>
      </div>
  
      <!-- Store Locations Section -->
      <!-- <div class="store-section text-center">
        <h4 class="mb-5 fw-semibold">Our Book Store</h4>
        <div class="row g-4 justify-content-center">
          <div class="col-md-4" v-for="(store, index) in stores" :key="index">
            <img :src="store.image" alt="Store Image" class="img-fluid rounded mb-3" />
            <h5 class="fw-semibold">{{ store.city }}</h5>
            <p class="text-muted mb-1">{{ store.address }}</p>
            <p class="text-muted mb-1">Hotline: {{ store.hotline }}</p>
            <p class="text-muted mb-3">{{ store.email }}</p>
            <h6 class="fw-semibold">Working Hours</h6>
            <p class="text-muted mb-0">Open: 8:00AM - Close: 18:00PM</p>
            <p class="text-muted">Saturday - Sunday: Close</p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/globals";

export default {
  name: "ContactPage",
  data() {
    return {
      isLoading: false,
      form: {
        name: "",
        email: "",
        message: "",
      },
      // stores: [
      //   {
      //     city: "New York",
      //     image:
      //       "https://demo2.pavothemes.com/bookory/wp-content/uploads/2022/02/contact_pic_1.png",
      //     address: "3164 N Delaware Rd Milan, Indiana(IN), 47031",
      //     hotline: "+(84) 2500 888 33",
      //     email: "support@example.com",
      //   },
      //   {
      //     city: "Las Vegas",
      //     image:
      //       "https://demo2.pavothemes.com/bookory/wp-content/uploads/2022/02/contact_pic_2.png",
      //     address: "3164 N Delaware Rd Milan, Indiana(IN), 47031",
      //     hotline: "+(84) 2500 888 33",
      //     email: "support@example.com",
      //   },
      //   {
      //     city: "Los Angeles",
      //     image:
      //       "https://demo2.pavothemes.com/bookory/wp-content/uploads/2022/02/contact_pic_3.png",
      //     address: "3164 N Delaware Rd Milan, Indiana(IN), 47031",
      //     hotline: "+(84) 2500 888 33",
      //     email: "support@example.com",
      //   },
      // ],
    };
  },
  methods: {
    async submitForm() {
      this.isLoading = true;
      const { name, email, message } = this.form;
      // Basic empty check
      if (!name.trim() || !email.trim() || !message.trim()) {
        this.$root.showToast({
          message: "Please fill in all required fields.",
          status: "danger",
          duration: 3000,
        });
        this.isLoading = false
        return;
      }
      try {
        const response = await axios.post(`${BASE_URL}/api/common/contact`, {
          name: this.form.name,
          email: this.form.email,
          message: this.form.message,
        });
        if (response.data.status) {
          this.$root.showToast({
            message: "Form submitted. Thanks!",
            status: "success",
            duration: 3000,
          });
          this.form = {
            name: "",
            email: "",
            message: "",
          };
        } else {
          this.$root.showToast({
            message: "Submission failed. Please try again later.",
            status: "danger",
            duration: 3000,
          });
        }
      } catch (error) {
        this.$root.showToast({
          message: "Submission failed. Please try again later.",
          status: "danger",
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.about-page {
  .title {
    font-size: 60px;
    font-weight: 600;
    text-align: start;
    background: #edebeb;
    padding: 60px 40px;
    margin-bottom: 100px;
  }

  .about-heading {
    font-size: 26px;
    font-weight: 600;
    line-height: 1.3;
    color: #000;
    // @media (min-width: 768px) {
    //   font-size: 1.75rem;
    // }
    // @media (min-width: 992px) {
    //   font-size: 2rem;
    // }
  }

  .about-image img {
    width: 90%;
    height: auto;
    border-radius: 20px;
  }
}

.our-story-section {
  padding: 0 100px;

  .story-title {
    font-size: 48px;
    font-weight: 600;
    color: #000;
    margin-bottom: 60px;

    @media (max-width: 768px) {
      font-size: 36px;
      margin-bottom: 40px;
    }
  }

  .story-card {
    padding: 0 30px;
    text-align: left;

    .story-card-title {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1px;
      color: #000;
      margin-bottom: 40px;
      text-transform: uppercase;

      @media (max-width: 768px) {
        font-size: 12px;
        margin-bottom: 15px;
      }
    }

    .story-card-text {
      font-size: 16px;
      line-height: 1.6;
      color: #666;
      margin: 0;
      max-width: 80%;

      @media (max-width: 768px) {
        font-size: 14px;
        line-height: 1.5;
      }
    }
  }

  .story-image {
    img {
      width: 100%;
      height: auto;
      border-radius: 20px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }
  }

  .bottom-text {
    p {
      font-size: 16px;
      line-height: 1.6;
      color: #666;

      @media (max-width: 768px) {
        font-size: 14px;
        line-height: 1.5;
      }
    }
  }

  // Responsive spacing adjustments
  @media (max-width: 768px) {
    padding: 0 20px;

    .row {
      margin-bottom: 30px !important;
    }
  }

  // Ensure proper spacing between sections
  .row + .row {
    margin-top: 60px;

    @media (max-width: 768px) {
      margin-top: 40px;
    }
  }
}

// Additional responsive utilities
@media (max-width: 576px) {
  .our-story-section {
    .col-md-6 {
      margin-bottom: 30px;
    }
  }
}
.contact-page {
  background: #fff;
  .title {
    font-size: 60px;
    font-weight: 600;
    text-align: start;
    background: #edebeb;
    padding: 60px 40px;
    margin-bottom: 100px;
  }

  .map-container {
    border-radius: 16px;
    overflow: hidden;
    iframe {
      border: 0;
      border-radius: 16px;
    }
  }

  .contact-title {
    font-weight: 600;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .contact-subtitle {
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 1.5rem;
  }

  .form-control {
    background: #f9f9f9;
    border: 1px solid #ddd;
    &:focus {
      box-shadow: none;
      border-color: #999;
    }
  }

  textarea.form-control {
    resize: none;
  }

  .btn-primary {
    background-color: #f85c50;
    border-color: #f85c50;
    transition: all 0.2s ease;
    &:hover {
      background-color: #e14c42;
      border-color: #e14c42;
    }
  }

  .store-section {
    margin-top: 150px;

    h4 {
      font-size: 1.8rem;
    }

    img {
      border-radius: 12px;
      max-height: 220px;
      object-fit: cover;
    }

    h5 {
      margin-top: 1rem;
      margin-bottom: 0.5rem;
    }

    h6 {
      margin-top: 1.5rem;
    }
  }
}
</style>
